<template>
  <div class="booking-confirmation-common main-content">
    <el-descriptions :column="24" :colon="false">
      <el-descriptions-item :span="3.5" label="Booking Received by Carrier:" />
      <el-descriptions-item :span="3.5">
        <el-tag type="info" style="margin-left: 5px;">{{ ediReceiptData[page-1].time }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item :span="17">
        <el-button v-show="showYdBookingResultButton" no="showYdBookingResult" @click="$emit('showYdBookingResult', 'tabVesselEq')">{{ $t('CargoMsg.Cargo_ReplaceSystemValue') }}</el-button>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions :column="14" :colon="false">
      <el-descriptions-item :span="2" label="Booking Confirmation Version:" />
      <el-descriptions-item :span="8">
        <div style="display: flex">
          <cargo-pagination
            layout="prev, pager, next"
            :limit="1"
            :page.sync="page"
            :total="ediReceiptData.length"
          />
        </div>
      </el-descriptions-item>
      <el-descriptions-item :span="2" label="Latest Amendment Time:" />
      <el-descriptions-item :span="2">
        <el-tag type="info">{{ lastReceiptTime + ' (UTC)' }}</el-tag>
      </el-descriptions-item>
    </el-descriptions>
    <div v-if="ediReceiptData[page-1].fileType === 'pdf' && ediReceiptData[page-1].pdfSrc" class="pdf-img">
      <el-scrollbar>
        <pdf v-for="i in ediReceiptData[page-1].numPages" :key="i" :src="ediReceiptData[page-1].pdfSrc" :page="i" />
      </el-scrollbar>
    </div>
    <div v-if="ediReceiptData[page-1].fileType === 'html' && ediReceiptData[page-1].htmlContent">
      <div style="background-color: white" v-html="ediReceiptData[page-1].htmlContent" />
    </div>
  </div>
</template>
<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import pdf from 'vue-pdf'
import { sleep } from '@/utils/commonUtil'
import { findByFileId } from '@/api/storage'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { RECEIPT_SOURCE_EMAIL, RECEIPT_SOURCE_YD } from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'BookingConfirmationCommon',
  components: { CargoAdvanceSelect, pdf },
  props: {
    ediReceiptData: { type: Array, required: true },
    jobNo: { type: String, required: true },
    lastReceiptTime: { type: String, required: true },
    job: { type: Object }
  },
  data() {
    return {
      acEdiReceipt: {
        remarks: ''
      },
      page: 1
    }
  },
  computed: {
    showYdBookingResultButton() {
      if ([RECEIPT_SOURCE_YD.code, RECEIPT_SOURCE_EMAIL.code].indexOf(this.ediReceiptData[this.page - 1].receiptSource) > -1 && this.job && (this.job.bookingState === SystemConstants.JOB_BOOKING_STATE_BOOKING_RECEIVED.code || this.job.bookingState === SystemConstants.JOB_BOOKING_STATE_BOOKING_CONFIRM.code)) {
        return true
      }
      return false
    }
  },
  watch: {
    page: {
      immediate: true,
      async handler() {
        const selectData = this.ediReceiptData[this.page - 1]
        if (selectData.fileType === 'pdf' && !selectData.pdfSrc && selectData.fileId) {
          const res = await findByFileId(selectData.fileId)
          if (res && res.data) {
            // const arrayBuffer = new Uint8Array(await res.data.arrayBuffer())
            // const loadingTask = pdf.createLoadingTask(arrayBuffer)
            // await loadingTask.promise.then(pdf => {
            //   selectData.numPages = pdf.numPages
            // })
            // selectData.pdfSrc = arrayBuffer
            const URL = window.URL || window.webkitURL
            const pdfUrl = URL.createObjectURL(res.data)
            const loadingTask = pdf.createLoadingTask({
              url: encodeURI(pdfUrl),
              cMapUrl: 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/',
              cMapPacked: true
            })
            await loadingTask.promise.then(pdf => {
              selectData.numPages = pdf.numPages
            })
            selectData.pdfSrc = loadingTask
            this.$forceUpdate()
          }
        } else if (selectData.fileType === 'html' && !selectData.htmlContent) {
          const res = await findByFileId(selectData.fileId)
          const reader = new FileReader()
          reader.onload = () => {
            selectData.htmlContent = reader.result
            this.$forceUpdate()
          }
          reader.readAsText(res.data)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.booking-confirmation-common {
  .warning{
    color: sandybrown;
  }
  .el-descriptions{
    background-color: transparent;
    margin-bottom: 10px;
    &__body{
      background-color: transparent;
    }
    &__header {
      margin-top: 10px;
      margin-bottom: 5px;
    }
    &__title{
      flex: 1;
      text-align: center;
    }
    .is-border{
      .el-descriptions-row{
        td {
          border-color: #DCDFE6!important;
        }
        th {
          border-color: #DCDFE6!important;
        }
      }
    }
    .is-bordered-label {
       background-color: #EBEEF5;
     }
    &-item {
      &__label{
        color:#333!important;
      }
      &__content {
        p{
          margin-top: 0;
          &:nth-last-child(1){
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .show-more {
    cursor: pointer;
    color: #1F75D5;
    text-align: center;
  }
  .pdf-img{
    height: 550px;
    .el-scrollbar{
      height: 550px;
      /deep/ .el-scrollbar__wrap{
        overflow-x: hidden;
      }
      /deep/ .el-scrollbar__bar{
        opacity: 1;
      }
    }
  }
}
</style>
